<template>
  <div>
    <div class="grey-subhead-bg text-uppercase">
      <h1>training Video</h1>
    </div>

    <div class="container">
      <br>
      <div class="row">
        <div class="col-xs-12 text-center yt-container">
          <!-- <img src="../../assets/images/rewards/vid-lrg-ph.jpg" class="img-responsive"> -->
          <!-- <iframe width="1130" height="635" src="https://www.youtube.com/embed/videoseries?list=PLx0sYbCqOb8TBPRdmBHs5Iftvv9TPboYG" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe> -->
          <youtube
            :video-id="youtubeIdFromUrl(training.videoUrl)"
            ref="youtube"
            :player-vars="playerVars"
            :resize="true"
            @ended="ended"></youtube>
          <h1>{{ training.moduleName }}</h1>
          <p>{{ training.description }}</p>
        </div>
        <div class="col-xs-6 col-xs-offset-3">
          <a
            href=""
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
            @click.prevent="goQuiz"
            :disabled="!finishedWatching"
          >
            Next
          </a>
          <router-link
            :to="{name: 'TrainingCatalog'}"
            type="button"
            class="btn client-btn-primary btn-lg btn-block text-uppercase"
          >
            Previous
          </router-link>
        </div>
      </div>

      <br><br>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
export default {
  name: 'TrainingModule',
  props: {
    training: {
      type: Object
    }
  },
  data () {
    return {
      finishedWatching: false,
      playerVars: {
        controls: 0,
        // disablekb: 1, // TODO: disable keyboard controls if necessary
        origin: process.env.VUE_APP_CLIENT_ORIGIN,
        rel: 0
      }
    }
  },
  mounted () {
  },
  methods: {
    youtubeIdFromUrl (url) {
      return this.$youtube.getIdFromUrl(url)
    },
    ended () {
      this.finishedWatching = true
    },
    goQuiz () {
      this.$bus.emit('swapComponent', { component: 'training-quiz' })
    }
  }
}
</script>

<style>
@media screen and (max-width: 687px) {
  .yt-container iframe {
    width: 100%;
  }
}
</style>
